import React, { useRef, useState, useEffect } from "react";
import get from "lodash/get";
import throttle from "lodash/throttle";
import { Link } from "@quintype/components";
import { useDispatch, useSelector } from "react-redux";

import { OPEN_SEARCHBAR } from "../../../store/actions";
import { MenuItem } from "../../menu-item";
import Logo from "../../../atoms/icons/logo";
import HamburgerNotification from "../../../molecules/hamburger-notification";
import SocialShareIcons from "../../../molecules/social-share-header";
import LatestButton from "../../../atoms/latest-button";
import EPaperButton from "../../../atoms/e-paper-button";
import MenuRight from "../../../atoms/icons/menu-right";
import HamburgerMenus from "../hamburger-menus";

import "./desktop-header.m.css";
import SearchBox from "../../../atoms/search-box";

const DesktopHeader = () => {
  const getState = useSelector((state) => state);
  const dispatch = useDispatch();

  const primaryMenus = get(getState, ["qt", "data", "navigationMenu", "primaryMenus"], []);
  const secondaryMenus = get(getState, ["qt", "data", "navigationMenu", "secondaryMenus"], []);

  const navRef = useRef();
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (typeof window !== "undefined") {
        if (window.scrollY > 105) {
          setIsSticky(true);
        }
        if (window.scrollY < 106) {
          setIsSticky(false);
        }
      }
    };

    window.addEventListener("scroll", throttle(handleScroll, 250));

    return () => {
      window.removeEventListener("scroll", throttle(handleScroll, 250));
    };
  }, []);

  const getPrimaryMenus = () => {
    return (
      <div styleName="menu-wrapper">
        {primaryMenus.slice(0, 10).map((item, index) => (
          <div key={index} styleName="primary-menu-item">
            <MenuItem
              type="primary"
              item={item}
              menuStyle="menu-link"
              toggleHandler={() =>
                dispatch({
                  type: OPEN_SEARCHBAR,
                  isSearchBarOpen: false
                })
              }
            />
            {item.children.length > 0 && (
              <>
                <div styleName="triangle"></div>
                <div styleName="ddsection">
                  <div styleName="ddsec1">
                    {item.children.slice(0, 8).map((subitem, idx) => (
                      <div key={idx} styleName="subitem">
                        <Link externalLink={subitem.isExternalLink} href={subitem && subitem?.url}>
                          {subitem.title}
                        </Link>
                      </div>
                    ))}
                  </div>
                  {item.children.length >= 8 && (
                    <div styleName="ddsec2">
                      {item.children.slice(8, 16).map((subitem, idx) => (
                        <div key={idx} styleName="subitem">
                          <Link externalLink={subitem.isExternalLink} href={subitem && subitem?.url}>
                            {subitem.title}
                          </Link>
                        </div>
                      ))}
                    </div>
                  )}
                  {item.children.length >= 16 && (
                    <div styleName="ddsec3">
                      {item.children.slice(16, 24).map((subitem, idx) => (
                        <div key={idx} styleName="subitem">
                          <Link key={index} externalLink={subitem.isExternalLink} href={subitem && subitem?.url}>
                            {subitem.title}
                          </Link>
                        </div>
                      ))}
                    </div>
                  )}
                  {item.children.length >= 24 && (
                    <div styleName="ddsec4">
                      {item.children.slice(24, 32).map((subitem, idx) => (
                        <div key={idx} styleName="subitem">
                          <Link key={index} externalLink={subitem.isExternalLink} href={subitem && subitem?.url}>
                            {subitem.title}
                          </Link>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    );
  };

  const getSecondaryMenus = () => {
    return (
      <div styleName="menu-wrapper secondary-menu-wrapper">
        {secondaryMenus.slice(0, 9).map((item, index) => (
          <div key={index} styleName="secondary-menu-item">
            <MenuRight />
            <MenuItem
              type="secondary"
              item={item}
              key={index}
              menuStyle="menu-link"
              toggleHandler={() =>
                dispatch({
                  type: OPEN_SEARCHBAR,
                  isSearchBarOpen: false
                })
              }
            />
            {item.children.length > 0 && (
              <>
                <div styleName="triangle"></div>
                <div styleName="ddsection">
                  <div styleName="ddsec1">
                    {item.children.slice(0, 8).map((subitem, idx) => (
                      <div key={idx} styleName="subitem">
                        <Link externalLink={subitem.isExternalLink} href={subitem && subitem?.url}>
                          {subitem.title}
                        </Link>
                      </div>
                    ))}
                  </div>
                  {item.children.length >= 8 && (
                    <div styleName="ddsec2">
                      {item.children.slice(8, 16).map((subitem, idx) => (
                        <div key={idx} styleName="subitem">
                          <Link externalLink={subitem.isExternalLink} href={subitem && subitem?.url}>
                            {subitem.title}
                          </Link>
                        </div>
                      ))}
                    </div>
                  )}
                  {item.children.length >= 16 && (
                    <div styleName="ddsec3">
                      {item.children.slice(16, 24).map((subitem, idx) => (
                        <div key={idx} styleName="subitem">
                          <Link key={index} externalLink={subitem.isExternalLink} href={subitem && subitem?.url}>
                            {subitem.title}
                          </Link>
                        </div>
                      ))}
                    </div>
                  )}
                  {item.children.length >= 24 && (
                    <div styleName="ddsec4">
                      {item.children.slice(24, 32).map((subitem, idx) => (
                        <div key={idx} styleName="subitem">
                          <Link key={index} externalLink={subitem.isExternalLink} href={subitem && subitem?.url}>
                            {subitem.title}
                          </Link>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    );
  };

  return (
    <>
      <div styleName="header">
        {isSticky ? (
          <div ref={navRef} styleName={`primary`}>
            <div className="container" styleName={`primary-wrapper`}>
              <div styleName="logo-wrapper">
                <Link href="/">
                  <Logo width={`76.67px`} height={`70px`} />
                </Link>
                <HamburgerNotification />
              </div>

              {getPrimaryMenus()}

              <SearchBox />
            </div>
          </div>
        ) : (
          <div ref={navRef} styleName={`primary`}>
            <div className="container" styleName={`primary-wrapper`}>
              <div styleName="logo-wrapper">
                <Link href="/">
                  <Logo width={`76.67px`} height={`70px`} />
                </Link>
              </div>

              {getPrimaryMenus()}

              <div styleName="share-icons-wrapper">
                <SocialShareIcons />
              </div>
            </div>
          </div>
        )}
        {!isSticky && (
          <div styleName={`secondary`}>
            <div className="container" styleName="secondary-wrapper">
              <div>
                <HamburgerNotification />
              </div>
              {getSecondaryMenus()}
              <div styleName="button-wrapper">
                <LatestButton />
                <EPaperButton />
                <SearchBox />
              </div>
            </div>
          </div>
        )}
      </div>
      <HamburgerMenus />
    </>
  );
};

export default DesktopHeader;
